import dayjs, { Dayjs } from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import React, { useEffect, useState } from 'react';

import 'dayjs/locale/en';
import 'dayjs/locale/kk';
import 'dayjs/locale/ru';

import { Calendar } from './calendar';
import { CalendarEvents } from './calendar-events';

dayjs.extend(updateLocale);
dayjs.updateLocale('kk', {
    weekStart: 0,
});
dayjs.updateLocale('ru', {
    weekStart: 0,
});

import './tax-calendar.scss';

type Props = {
    translations: Record<string, string>;
    language: string;
};

const TaxCalendar = ({ translations, language }: Props) => {
    const [selectedDay, setSelectedDay] = useState<Dayjs>(() => {
        return dayjs().locale(language);
    });

    useEffect(() => {
        dayjs.locale(language);
    }, [language]);

    return (
        <div className="tax-calendar">
            <Calendar
                selectedDay={selectedDay}
                selectDay={(day) => setSelectedDay(day)}
                translations={translations}
            />

            <CalendarEvents
                selectedDay={selectedDay}
                selectDay={(day) => setSelectedDay(day)}
                translations={translations}
            />
        </div>
    );
};

export default TaxCalendar;
